import { type ImgSize } from "../../img-size-type";

export interface PaymentImageData {
    width: number;
    height: number;
    url: string;
}
export type InputImageData = {
    url: string;
} & ({ width: number } | { height: number });
export function createPaymentImageData(
    originalSize: ImgSize,
    ...data: InputImageData[]
) {
    const result: PaymentImageData[] = [];
    for (const d of data) {
        if ("width" in d) {
            result.push({
                width: d.width,
                height: (d.width / originalSize.width) * originalSize.height,
                url: d.url,
            });
        } else {
            result.push({
                height: d.height,
                width: (d.height / originalSize.height) * originalSize.width,
                url: d.url,
            });
        }
    }
    return result;
}
